import {
  ALWAYS_ON_PROTECTED_HOUSING_DOCUMENTS,
  CIVIL_STATUS_DECLARATION,
  CIVIL_STATUSES,
  PROTECTED_HOUSING_DECLARATIONS,
  PROTECTED_HOUSING_DOCUMENTS,
  normalizeProtectedHousingDeclarations,
  normalizeProtectedHousingDocuments,
  normalizeRequirementsConfig,
} from "../../utils/workspaceRequirements";
import { Row } from "./WorkspaceRequirementsConfig";

// Hidden for now: only the declarations option is shown. Set to true to show
// the document options again (their saved values are kept either way).
const SHOW_DOCUMENTS = false;

// Protected housing (VPO), its declarations and documents. A full-width card under the
// requirements card and the profile simulator: the declaration names are long.
export default function ProtectedHousingCard({ form, onChange }) {
  const config = form.requirements_config;
  const declarations = config.protected_housing_declarations;
  const documents = config.protected_housing_documents;

  const setDeclarations = (active) =>
    onChange({
      requirements_config: normalizeRequirementsConfig({
        ...config,
        protected_housing_declarations: { active },
      }),
    });
  const setDocument = (key, value) =>
    onChange({
      requirements_config: normalizeRequirementsConfig({
        ...config,
        protected_housing_documents: { ...documents, [key]: value },
      }),
    });
  // Turning protected housing off turns its declarations and documents off
  const setProtectedHousing = (value) =>
    onChange({
      protected_housing_enabled: value,
      requirements_config: normalizeRequirementsConfig({
        ...config,
        protected_housing_declarations: normalizeProtectedHousingDeclarations(
          declarations,
          value,
        ),
        protected_housing_documents: normalizeProtectedHousingDocuments(
          documents,
          value,
        ),
      }),
    });

  return (
    <div className="lw-rq-card lw-rq-wide">
      {/* <div className="lw-rq-title">
        <h3>Protected housing</h3>
        <Tip text="Protected housing (VPO) and the declarations and documents the tenant is asked for." />
      </div> */}
      <Row
        label="VPO"
        tip={
          form.catella_rules_activated
            ? "Always on for Catella workspaces."
            : "Turns on protected housing (VPO) for this workspace."
        }
        checked={form.protected_housing_enabled}
        disabled={form.catella_rules_activated}
        onChange={setProtectedHousing}
      >
        {form.protected_housing_enabled && (
          <div className="lw-rq-subs">
            <Row
              sub
              label="Declarations"
              tip="The tenant is asked for all of these declarations."
              checked={declarations.active}
              onChange={setDeclarations}
            >
              {declarations.active && (
                <ol className="lw-rq-declarations">
                  {PROTECTED_HOUSING_DECLARATIONS.map((label, index) => (
                    <li key={label}>
                      {label}
                      {index === CIVIL_STATUS_DECLARATION && (
                        <ul className="lw-rq-statuses">
                          {CIVIL_STATUSES.map((status) => (
                            <li key={status}>{status}</li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ol>
              )}
            </Row>
            {SHOW_DOCUMENTS &&
              PROTECTED_HOUSING_DOCUMENTS.map(([key, label]) => (
                <Row
                  sub
                  key={key}
                  label={label}
                  tip={
                    ALWAYS_ON_PROTECTED_HOUSING_DOCUMENTS.includes(key)
                      ? "Always asked for in protected housing."
                      : undefined
                  }
                  checked={documents[key]}
                  disabled={ALWAYS_ON_PROTECTED_HOUSING_DOCUMENTS.includes(key)}
                  onChange={(value) => setDocument(key, value)}
                />
              ))}
          </div>
        )}
      </Row>
    </div>
  );
}
